export default "__VITE_ASSET__48799039__"